module.exports = __webpack_public_path__ + "static/media/ice38.5272b26b.webp";